<template>
    <div class="container">
        <img src="@/assets/images/connectfn_moved.png" alt="ConnectFN Moved">
        <h1>{{$t('page_not_found.link_not_working')}}</h1>
        <h2> <p>{{$t('page_not_found.contact_sales_rep')}}</p>
        <p v-html="$t('page_not_found.please_visit', { netroadshow_link: `<a href='https://www.netroadshow.com'>NetRoadshow</a>` })"></p></h2>
        <br/>
        <a href="https://www.netroadshow.com/nrs/home/#!/contact-us/production">{{$t('page_not_found.contact_us')}}</a>
    </div>
</template>

<script setup>
</script>

<style lang="stylus" scoped>
.container
    margin 100px auto 0
    padding 40px 30px
    right 0
    left 0
    width 100%
    height 100%
    overflow hidden
    overflow-y auto
    text-align center
    h1
        font-weight 500
        color #3a3a3a
        text-align center
        font-size 30px
        margin 20px 0
    h2
        font-weight 400
        color #4c4c4c
        text-align center
        font-size 18px
        padding 15px
        margin 15px 0
        p
            line-height 2
            a
                font-size 18px
    a
        color #2389f1
        font-size 14px
        text-decoration none
        padding-bottom 20px
    @media (max-width: 992px) {
    padding 0
    margin-top 0
  }
</style>
